<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <main class="flex h-full items-center justify-center">
    <div class="p-6">
      [file: pages/bank/[bank]/map/[...type].vue, params: {{ route.params || 'null' }}]
    </div>
  </main>
</template>
